import React, { useEffect, useState } from "react";
import './invoice.css';
import logo from "../../assets/newlogo.png";
import sign from "../../assets/sign.png";
import axios from "axios";
import { Form, Table } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { FaDownload, FaPrint, FaEdit, FaShareAlt, FaWhatsapp } from "react-icons/fa";

function Invoice({ onLogout }) {
  // const API_URL = "http://localhost:8000/invoice.php";
  const API_URL = "https://crm.fazoacademy.in/php/invoice.php";



  const [studentList, setStudentList] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isEditingTerms, setIsEditingTerms] = useState(false);

  const defaultTerms = `
    <li>Students should maintain timing and must not take unnecessary leave.</li>
    <li>Once enrolled, the amount is not refundable.</li>
    <li>Trainers are working professionals; students must cooperate with their availability.</li>
    <li>Course duration may extend based on candidate’s ability.</li>
    <li>No mobile phones allowed during training unless instructed by faculty.</li>
  `;
  const [editedTerms, setEditedTerms] = useState(defaultTerms);

  const fetchStudent = async () => {
    try {
      const response = await axios.get(API_URL);
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);
      setStudentList(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching students:", error);
      setStudentList([]);
    }
  };

  useEffect(() => {
    fetchStudent();
  }, []);

  const handleStudentClick = (student) => {
    setSelectedStudent(student);
    console.log("Selected Student:", student);
  };


  function numberToWords(num) {
    const a = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven',
      'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen',
      'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if (num === 0) return 'Zero';
    if (num < 20) return a[num];
    if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
    if (num < 1000)
      return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' and ' + numberToWords(num % 100) : '');
    if (num < 100000)
      return numberToWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + numberToWords(num % 1000) : '');
    if (num < 10000000)
      return numberToWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + numberToWords(num % 100000) : '');
    return 'Amount too large';
  }

  const handlePrint = () => {
    const printContent = document.getElementById("invoice-id").innerHTML;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    setTimeout(() => {
      document.body.innerHTML = originalContent;
      window.location.reload();
    }, 100);
  };

  const handleDownloadPDF = () => {
    const input = document.getElementById("invoice-id");
    if (!input) {
      alert("Invoice content not found.");
      return;
    }



    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("invoice.pdf");
    });
  };

  // const handleWhatsapp = () => {
  //   const studentName = "John Doe"; // You can get this dynamically if needed
  //   const studentId = 123; // from your data
  //   const invoiceLink = `https://yourdomain.com/invoice/${studentId}`;

  //   const message = `Hello ${studentName}, here is your invoice: ${invoiceLink}`;

  //   const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  //   window.open(whatsappUrl, "_blank");
  // };


  return (
    <>
      <div className="navigation">
        <a href="#">Invoice</a> / <a href="#" onClick={onLogout}>Logout</a>
      </div>

      <div className="row mb-3">
        <div className="col-md-2">
          <Form.Select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
            className="pagination-select"
          >
            <option value="10">Show 10</option>
            <option value="20">Show 20</option>
            <option value="30">Show 30</option>
          </Form.Select>
        </div>
      </div>
      {/* <div className="invoice-wrapper d-flex">
      <div className="student-table-container me-3"> */}
      <Table striped bordered hover className="course-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Student Name</th>
            <th>Student Id</th>
            <th>Phone Number</th>
            <th>Course Name</th>
          </tr>
        </thead>
        <tbody>
          {studentList.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">No data found</td>
            </tr>
          ) : (
            studentList.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleStudentClick(item);
                    }}
                  >
                    {item.student_id}
                  </a>
                </td>
                <td>{item.phonenumber}</td>
                <td>{item.coursedetails}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      {/* </div> */}

      {selectedStudent && (
        <>
          {/* <div className="invoice-display"> */}
          <div className="invoice-actions">
            <button onClick={handlePrint}>
              <FaPrint style={{ marginRight: "5px" }} />
              Print
            </button>
            <button onClick={handleDownloadPDF}>
              <FaDownload style={{ marginRight: "5px" }} />
              Download PDF
            </button>


          </div>

          <div className="invoice-container" id="invoice-id">
            {/* Header */}
            <div className="invoice-header p-1">
              <div className="invoice-main d-flex">
                <img src={logo} width="168px" height="168px" alt="Logo" />
                <div className="invoice-company">
                  <h1 className="invoice-title">Fazo Academy</h1>
                  <p>No:21, Vinayaga Nagar,<br /> Okkiyam Thoraipakkam<br />Chennai, Tamil Nadu <br />600097, India</p>
                </div>
              </div>

              <div className="invoice-details mt-3">
                <h2 className="invoice-subtitle">INVOICE</h2>
                <p># {selectedStudent.student_id}</p>
                <p>Invoice Date: {new Date().toLocaleDateString('en-GB')}</p>
                <p>Terms: Due on Receipt</p>
                {/* <p>Due Date: {selectedStudent.level2date}</p> */}
                {selectedStudent.paymentstatus?.toLowerCase().replace(/\s/g, '') === "paid" && (
                  <p>Payment Date: {selectedStudent.paymentdate}</p>
                )}

                {selectedStudent.paymentstatus?.toLowerCase().replace(/\s/g, '') === "partiallypaid" && (
                  <p>Due Date: {selectedStudent.level2date}</p>
                )}



              </div>
            </div>

            {/* Bill To */}
            <div className="invoice-billto">
              <h3 className="bold">Bill To</h3>
              <p className="mb-0">{selectedStudent.name}</p>
              <p className="mb-0">{selectedStudent.address}</p>
              <p className="mb-0">{selectedStudent.city}</p>
              <p className="mb-0">{selectedStudent.pincode}</p>
              <p className="mb-0">{selectedStudent.phonenumber}</p>
            </div>

            {/* Item Table */}
            <table className="invoice-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item & Description</th>
                  {/* <th>Qty</th> */}
                  <th>Rate</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>{selectedStudent.coursedetails}<br /><span className="text-small">REAL TIME TRAINING</span></td>
                  {/* <td>1.00</td> */}
                  <td>{selectedStudent.fees}</td>
                  <td>{selectedStudent.fees}</td>
                </tr>
              </tbody>
            </table>

            {/* Summary */}
            {(() => {
              const total = parseFloat(selectedStudent.offerfees || 0) - parseFloat(selectedStudent.level1amount || 0);
              return (
                <>
                  <div className="invoice-summary">
                    <div className="invoice-summary1"></div>
                    <div className="invoice-summary2">
                      <p className="line-item">
                        <span>Sub Total:</span>
                        <span>{selectedStudent.fees}</span>
                      </p>
                      <p className="line-item">
                        <span>Discount:</span>
                        <span> (-)&nbsp; {selectedStudent.discountamount}</span>
                      </p>
                      <p className="line-item">
                        <span>Offer Price:</span>
                        <span>{selectedStudent.offerfees || 0}</span>
                      </p>
                      <p className="line-item">
                        <span>Paid:</span>
                        {/* <span>{selectedStudent.level1amount}</span> */}
                        {selectedStudent.paymentstatus?.toLowerCase().replace(/\s/g, '') === "paid" && (
                          <span>{selectedStudent.paidamount}</span>
                        )}

                        {selectedStudent.paymentstatus?.toLowerCase().replace(/\s/g, '') === "partiallypaid" && (
                          <span>{selectedStudent.level1amount}</span> 
                        )}
                      </p>
                      <p className="line-item bold">
                        <span>Total:</span>
                        <span>{total}.00</span>
                      </p>
                      <p className="line-item bold text-red">
                        <span>Balance Due:</span>
                        {/* <span>{total}.00</span> */}
                                        {selectedStudent.paymentstatus?.toLowerCase().replace(/\s/g, '') === "paid" && (
                          <span>0.00</span>
                        )}

                        {selectedStudent.paymentstatus?.toLowerCase().replace(/\s/g, '') === "partiallypaid" && (
                          <span>{total}</span> 
                        )}
                      </p>
                      <div>
                        <img src={sign} width="220px" height="114px" />
                        <p style={{ textAlign: "center", margin: "10px" }}>Authorized Signature</p>
                      </div>
                    </div>
                  </div>

                  {/* Total in Words */}
                  <div className="invoice-words">
                    <p className="bold">Total in Words: <span className="italic">Indian Rupee {numberToWords(total)} Only</span></p>
                  </div>
                </>
              );
            })()}

            {/* Notes and Editable Terms */}
            <div className="invoice-footer">
              <div>
                <h3 className="bold">Notes</h3>
                <p>Thanks for choosing Fazo Academy.</p>

                <h3 className="bold" style={{ marginTop: "20px" }}>
                  Terms & Conditions
                  <FaEdit
                    className="edit-icon" size={15}
                    style={{ marginLeft: "10px", cursor: "pointer", color: "gray" }}
                    onClick={() => setIsEditingTerms(!isEditingTerms)}
                  />
                </h3>

                {isEditingTerms ? (
                  <ul
                    contentEditable
                    suppressContentEditableWarning={true}
                    className="editable-terms"
                    onBlur={(e) => {
                      setEditedTerms(e.currentTarget.innerHTML);
                      setIsEditingTerms(false);
                    }}
                    dangerouslySetInnerHTML={{ __html: editedTerms }}
                  />
                ) : (
                  <ul dangerouslySetInnerHTML={{ __html: editedTerms }} />
                )}
              </div>
            </div>
          </div>
          {/* </div> */}
        </>

      )}
      {/* </div> */}
    </>
  );
}

export default Invoice;
